<div class="bp-modal">
	<div class="bp-modal-body-section mod-wide p-30 color-black">
		<div class="center-block text-center">
			<h4 class="font-size-24 no-hyphens mb-30 text-left font-bold">{{ "agree_before_continue" | translate }}</h4>
			<bp-switch [model]="termsSlider" field="accepted">
				<div left>
					<div class="font-size-13 text-left no-hyphens mr-10">
						{{ "best_two_legal_text_part_1" | translate }}
						<a [href]="getTermsLink()" target="_blank">{{ "best_two_legal_text_part_2" | translate }}</a>
						{{ "best_two_legal_text_part_3" | translate }}
					</div>
				</div>
			</bp-switch>

			<div class="mt-30 items-center justify-end">
				<button
					type="button"
					class="btn btn-link mr-10 font-size-15 color-black font-medium"
					(click)="answer(false)">
					{{ "cancel" | translate }}
				</button>
				<button type="button" class="btn btn-primary font-size-15 pl-20 pr-20" (click)="answer(true)">
					{{ "Continue" | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
